export const ja = {
  app: {
    name: '3DGS Explorer',
  },
  common: {
    newVersionDetected: '新しいバージョンがあります。最新の内容を取得するには更新してください。',
    refreshNow: '今すぐ更新',
  },
  explore: {
    scaffoldHint: '現在の sceneId =',
  },
  errors: {
    notFound: 'ページが見つかりません',
    'missing-scene-id': 'scene-id パラメータがありません',
    'scene-offline': 'このシーンはオフラインです',
    'preview-token-invalid': 'プレビュートークンが無効または期限切れです',
    back: '戻る',
    'access-denied': 'アクセス拒否',
    'access-denied-desc': 'このシーンを表示する権限がありません。作成者に招待を依頼してください。',
    'access-denied-login': 'ログイン',
    'back-to-platform': 'プラットフォームに戻る',
    'scene-not-found': 'シーンが見つかりません',
    'scene-not-found-desc': 'お探しのシーンは存在しないか、削除されました。',
  },
  scene: {
    by: '作成者',
    noDescription: '説明はありません。',
  },
  share: {
    'link-copied': 'リンクをコピーしました',
    'copy-failed': 'コピーに失敗しました',
    'copy-permission-denied':
      'クリップボードの権限が拒否されています。リンクを手動でコピーしてください。',
    share: '共有',
    'close-share': '共有を閉じる',
  },
  toolbar: {
    vrMode: 'XR',
    sceneInfo: 'シーン情報',
    goBack: '戻る',
    flyMode: 'フライモード',
    walkMode: 'ウォークモード',
    orbitMode: 'オービットモード',
    screenshot: 'スクリーンショット',
    measureTool: '計測',
    exitMeasure: '計測終了',
    playCinematic: 'シネマティック再生',
    pauseCinematic: 'シネマティック一時停止',
    hotspots: 'ホットスポットを開く',
    closeHotspots: 'ホットスポットを閉じる',
    close: '閉じる',
    cancel: 'キャンセル',
    vrWebglTitle: 'WebGLモードに切り替え',
    vrWebglDesc:
      'VRにはWebGLレンダリングが必要です。ページを再読み込みします。読み込み完了後、もう一度VRボタンをクリックしてください。',
    vrWebglConfirm: 'WebGLに切り替え',
    vrQualityTitle: 'VR品質を選択',
    vrQualityLowest: '最低',
    vrQualityLow: '低',
    vrQualityMedium: '中',
    vrQualityHigh: '高',
    vrQualityHigher: 'やや高',
    vrQualityHighest: '最高',
    firstPerson: '一人称',
    thirdPerson: '三人称',
    characterRoam: 'キャラクター散策',
    flyDesc: 'Q/Eで昇降',
    walkDesc: 'Tabで視点切替',
    orbitDesc: 'ドラッグで回転',
    cinema: '3D レーストラック',
    assetLibrary: 'アセットライブラリ',
  },
  raceTrack: {
    pause: '一時停止 (スペース)',
    play: '再生 (スペース)',
    needKeyframes: '再生には2つ以上のキーフレームが必要です ({{count}}/2)',
    hidePreview: 'プレビューを非表示',
    showPreview: 'プレビューを表示',
    lookMode: 'ルックモード',
    lookAuto: '自動',
    lookForward: '前方',
    lookCenter: '中心',
    interpolation: '補間',
    interpolationStep: 'ステップ',
    interpolationSpline: 'スプライン',
    smooth: 'スムーズ',
    addKeyframe: '現在のカメラ位置にキーフレームを追加 (F)',
    updateKeyframe: 'キーフレームを現在のカメラに更新 (U)',
    deleteSelected: '選択したキーフレームを削除 (Delete/Backspace)',
    deleteAll: 'すべてのキーフレームを削除',
    jumpToStart: '先頭にジャンプ (G)',
    jumpToPrevious: '前のキーフレームにジャンプ (H)',
    jumpToNext: '次のキーフレームにジャンプ (L)',
    jumpToEnd: '末尾にジャンプ (;)',
    undoOptimize: '最適化を取り消す',
    optimizeTrack: 'トラックを最適化',
    exportVideo: '動画をエクスポート',
    closeEditor: 'エディターを閉じる',
    timelineTrack: 'タイムライントラック',
    keyframeAt: '{{time}}s のキーフレーム',
    playhead: '再生ヘッド',
    preview: 'プレビュー',
    aspectRatio: 'アスペクト比',
    closePreview: 'プレビューを閉じる',
    loadingPreview: 'プレビューを読み込み中',
    resizeHandle: 'リサイズ',
    previewFailed: 'プレビューに失敗しました',
    exportTitle: '動画をエクスポート',
    resolution: '解像度',
    resolutionSquare: 'スクエア 1080p (1080×1080)',
    resolution1080p: 'フルHD 1080p (1920×1080)',
    resolution720p: 'HD 720p (1280×720)',
    resolutionOriginal: 'オリジナルビューポート',
    frameRate: 'フレームレート',
    fps24: '24 fps (フィルム)',
    fps30: '30 fps (標準)',
    fps60: '60 fps (スムーズ)',
    codec: 'コーデック',
    codecH264: 'H.264 / AVC',
    codecVp9: 'VP9',
    codecVp8: 'VP8',
    quality: '品質',
    qualityStandard: '標準',
    qualityHigh: '高',
    qualityUltra: '最高',
    exporting: 'エクスポート中…',
    exportProgress: 'エクスポート進捗',
    exportFailed: 'エクスポートに失敗しました',
    cancel: 'キャンセル',
    sceneNotReady: 'シーンがエクスポートの準備ができていません',
    needTwoKeyframes: '動画をエクスポートするには2つ以上のキーフレームが必要です',
    sceneTimeout: 'シーンの読み込みがタイムアウトしました。エクスポートを開始できません',
    mediaRecorderUnsupported: 'このブラウザでは MediaRecorder がサポートされていません',
    exportCanvasFailed: 'エクスポート録画キャンバスの作成に失敗しました',
  },
  assetLibrary: {
    title: 'アセットライブラリ',
    close: '閉じる',
    translate: '移動',
    rotate: '回転',
    scale: 'スケール',
    dropHint: 'GLB/GLTF ファイルまたはフォルダをドラッグ、またはクリックして選択',
    urlPlaceholder: 'または URL を入力...',
    import: 'インポート',
    selectModel: 'モデルを選択してトランスフォームを編集',
    position: '位置',
    rotation: '回転 (rad)',
    scaleLabel: 'スケール',
    noModels: 'まだモデルがインポートされていません',
    duplicate: 'モデルを複製',
    rename: '名前を変更',
    delete: 'モデルを削除',
    gltfNotSupported:
      '.gltf 形式には外部リソースファイルが必要です。インポート前に .glb に変換してください。',
    importFailed: 'モデルのインポートに失敗しました。ファイル形式を確認してください。',
    unsupportedFormat: '.glb および .gltf ファイルのみサポートされています',
    folderSelect: 'フォルダを選択',
  },
  hotspots: {
    title: 'ホットスポット',
    sceneNavigation: 'シーンナビゲーション',
    close: 'ホットスポットを閉じる',
    empty: 'このシーンにホットスポットはありません。',
    flyTo: 'この関心地点に飛ぶ。',
    previous: '前のホットスポット',
    next: '次のホットスポット',
    openHotspot: 'ホットスポットを開く {{title}}',
    hotspot: 'ホットスポット',
    closeHotspot: 'ホットスポットを閉じる',
    noDescription: '説明はありません。',
  },
  user: {
    feedback: 'フィードバック送信',
    feedbackTitle: 'フィードバック送信',
    feedbackPlaceholder: 'フィードバックを入力してください…',
    feedbackSubmit: '送信（API準備中）',
    points: 'ポイント',
    pointsLoading: '読み込み中…',
    pointsAvailable: 'クレジット',
    pointsTotalGranted: '累計獲得',
    pointsTotalConsumed: '消費済み',
    pointsFailed: '未ログインまたは取得失敗',
    userInfo: 'ユーザー情報',
    login: 'ログイン',
    logout: 'ログアウト',
    notLoggedIn: '未ログイン',
    user: 'ユーザー',
  },
};
